import { css } from '@emotion/react';
import styled from '@emotion/styled';

import Button from 'components/field/Button';

import { Breakpoints } from 'utils/const.styles';

export const ContentWrapper = styled.div`
	z-index: var(--z-index-9);
`;

export const ButtonCss = css`
	margin: auto;
`;

export const MenuContainer = styled.div`
	display: flex;
	flex-direction: row;
	gap: 1rem;

	&.row-menu {
		flex-direction: row-reverse;

		.button {
			&.menu-item {
				&.rotate {
					> .icon {
						rotate: 90deg;
					}

					body[dir='rtl'] & {
						> .icon {
							rotate: 270deg;
						}
					}
				}
			}
		}
	}
`;

export const Menu = styled.ul`
	list-style: none;
	padding: 0;
	margin: 0;
	background-color: var(--modal-bg-3);
	box-shadow: var(--container-box-shadow);
	border-radius: var(--small-border-radius);
	padding: var(--padding-2);
	height: fit-content;
	> * {
		margin-bottom: var(--spacing-1);
	}

	> :last-child {
		margin-bottom: unset;
	}

	> .button {
		&.menu-item {
			justify-content: space-between;

			&.rotate {
				> .icon {
					rotate: 270deg;
				}

				body[dir='rtl'] & {
					> .icon {
						rotate: 90deg;
					}
				}
			}
		}
	}

	@media ${Breakpoints.mobile} {
		padding: var(--padding-4) 0;
		width: 100%;
	}
`;

export const MenuItem = styled.li`
	display: flex;
	align-items: center;
	gap: 0.5rem;
	cursor: pointer;
	background-color: var(--modal-bg-3);
	padding: var(--padding-3);
	border-radius: var(--small-border-radius);

	&.red-item {
		> .typography,
		> .icon {
			color: var(--red) !important;
		}

		:not(.disabled):hover {
			background-color: var(--red-10) !important;
		}
	}
	&.green-item {
		> .typography,
		> .icon {
			color: var(--green) !important;
		}

		:not(.disabled):hover {
			background-color: var(--green-10) !important;
		}
	}

	&.disabled {
		background: var(--background-5);
		color: var(--content-4) !important;
		opacity: 1;
		cursor: not-allowed;
		border-radius: 0;

		> .icon,
		> .typography {
			color: var(--content-4) !important;
		}
	}

	@media ${Breakpoints.mobile} {
		background-color: var(--background-3);
		margin: var(--padding-3);
		> .typography {
			font-weight: 500;
		}
	}

	:first-of-type {
		border-top-left-radius: var(--small-border-radius);
		border-top-right-radius: var(--small-border-radius);
	}

	:last-of-type {
		border-bottom-left-radius: var(--small-border-radius);
		border-bottom-right-radius: var(--small-border-radius);
	}

	&:hover:not(.disabled) {
		background-color: var(--table-selected-color);
	}

	> .typography,
	> .icon {
		color: var(--black);
		font-size: var(--paragraph3-font-size);
	}
`;

export const Line = styled.div`
	width: 100%;
	height: 1px;
	min-height: 1px;
	background-color: var(--black-10);
	margin: var(--spacing-1) 0;
`;

export const HeaderMenu = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 0.5rem 0.5rem;

	> button {
		flex: 1;
		border-color: var(--black-10) !important;

		> .typography {
			white-space: nowrap;
		}

		&.disabled {
			background: var(--background-5);
			color: var(--content-4);
			opacity: 1;
			cursor: not-allowed;

			> .icon,
			> .typography {
				color: var(--content-4);
			}
		}
	}
`;

export const MenuButtonContent = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;
`;

export const ActionMenuButton = styled(Button)`
	&.transparent&.disabled {
		background-color: var(--background-5);

		> .icon > svg,
		> .typography {
			color: var(--content-4);
		}
	}

	@media ${Breakpoints.mobile} {
		border: 1px solid var(--black-10) !important;
	}
`;

export const PopperContainer = styled.div`
	padding: 0 3rem;

	@media ${Breakpoints.mobile} {
		padding: 0;
	}
`;

export const StyledMenuButton = styled(Button)`
	padding: var(--padding-3) !important;

	&.transparent {
		:not(.disabled):hover {
			background-color: var(--table-selected-color) !important;
		}
	}
`;
